import { ReactNode } from "react";

import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import Tile from "ds/components/Tile";
import TileTitle from "ds/components/Tile/Title";
import { IconComponent } from "types/Icon";

type ManagementStrategyItemProps = {
  active: boolean;
  selected: boolean;
  title: string;
  icon: IconComponent;
  children: ReactNode;
  onSelect: () => void;
};

const ManagementStrategyItem = ({
  active,
  selected,
  children,
  icon,
  title,
  onSelect,
}: ManagementStrategyItemProps) => (
  <Tile
    indicator="radio"
    selected={selected}
    onClick={onSelect}
    icon={icon}
    title={
      <Box gap="medium" align="center">
        <TileTitle>{title}</TileTitle>
        {active && <Badge variant="green" type="strong" text="Active" />}
      </Box>
    }
    description={children}
  />
);

export default ManagementStrategyItem;
